// extracted by mini-css-extract-plugin
export var card = "_6m-0";
export var failedIcon = "_6m-4";
export var failedIconBadge = "_6m-3";
export var icon = "_6m-1";
export var successIcon = "_6m-2";